<div class="main_content">
    <div #page_section class="page_main_sec">
        <div class="OpenSearch_main_sec">
            <!-- title bar section Start-->
            <div class="container-fluid">
                <div class="post-nav-wrap">
                    <div class="title-wrap">
                        <p class="title">Field Mapping Setup</p>
                    </div>
                    <ul class="nav top-actions">
                        <li>
                            <a [routerLink]="['/home']">
                                <i class="material-icons theme-text-color">home</i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- title bar section  End-->
        </div>
        <div class="tab-content">
            <div>
                <!-- Table View -->
                <div class="table_card_sec mb_0 ">
                    <div class="table scroll_table ">
                        <div class="row">
                            <div class="col-lg-3">
                                <mat-form-field [style.width.%]="100">
                                    <mat-label for="Work_item_type">Work Item Type</mat-label>
                                    <mat-select [(ngModel)]="selectedDocumentType" (selectionChange)="get_field_mapping_detail();" id="Work_item_type">
                                        <mat-option *ngFor="let doc of lstDocumentType" [value]="doc.value">
                                            {{doc.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <button type="button " class="btncss me-2 " (click)="get_field_mapping_detail(); ">Refresh</button>
                            </div>
                            <div class="col-lg-3"></div>
                            <div class="col-lg-3">
                                <button type="button" class="btncss me-2 btn_primary" (click)="Save_Field_mapping_Details()">Save</button>
                            </div>
                        </div>
                        <div class="row advance-search-wrp ">
                            <!-- Basic Grid for filtered Data to display Start -->
                            <div class="grid_panel">
                                <app-standard-gridview *ngIf="lstFieldMapping.length> 0" [lstData]="lstFieldMapping" [columnsToHide]="advanceSearchColumnsToHide" [gridTitle]="'Field Mapping Data'" [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                                    [showPagination]="true" (cellClickEvent)="advanceSearchCellClick($event)" [recordsPerPage]="75"></app-standard-gridview>
                            </div>
                            <!-- Basic Grid for filtered Data to display Start -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>